import React from "react";
import { Route, Redirect } from "react-router-dom";

import AsyncComponent from "../../AsyncComponent";

import Helper from '../../../components/HelpButton';

const SideBar = AsyncComponent(() => import("../../../components/SideBar"));
const Header = AsyncComponent(() => import("../../../components/Header"));

export default function PrivateRoute({
    component: Component,
    ...rest
}) {
    const { currentUser,
        authenticated,
        top_loading,
        setMenuStatus,
        firebase,
        onLogout,
        hasMenu,
        helpers
    } = rest;

    let isAdmin = false;
    if (currentUser.sa) {
        isAdmin = (currentUser.sa === currentUser.uid);
    }

    return (
        <Route
            {...rest}
            render={props => {
                return  authenticated === true ? (
                    <div className={"az-body az-body-sidebar az-body-dashboard-nine" + (hasMenu ? " az-sidebar-show" : " az-sidebar-hide")}>
                        <img className={"imgLoading2" + (top_loading ? " show" : "")} src={process.env.PUBLIC_URL + "/assets/images/loading2.gif"} alt="loading" />
                        <SideBar isAdmin={isAdmin} currentUser={currentUser} />
                        <div className={"az-content az-content-dashboard-nine"} style={{ "position": "relative", "height": "100%", "width": "100%" }}>
                            <Header currentUser={currentUser} getScore={firebase.user.getScore} setMenuStatus={setMenuStatus} logout={onLogout} />
                            <Helper helpers={helpers} />
                            
                            <Component {...rest} {...props} />

                        </div>
                    </div>
                ) : (
                        <Redirect to="/login" />
                    )
                
            }}
        />
    );
}
